import React from 'react';
import { NavLink } from 'react-router-dom';
import './Navbar.css';

const Navbar = () => {
    return (
        <div className='mt-4'>
            <nav className="navbar navbar-expand-lg navbar-light">
                <div className="container-fluid">
                    <h4 className='logo'><NavLink to='/home'>Mishary Rafique</NavLink></h4>
                    <button className="navbar-toggler" type="button" data-bs-toggle="collapse" data-bs-target="#navbarNav" aria-controls="navbarNav" aria-expanded="false" aria-label="Toggle navigation">
                        <span className="navbar-toggler-icon"></span>
                    </button>
                    <div className="collapse navbar-collapse" id="navbarNav">
                        <ul className="navbar-nav">
                            <li className="nav-item links">
                                <a href='/home#about'>About</a>
                            </li>
                            <li className="nav-item links">
                                <a href='/home#contact'>Contact</a>
                            </li>
                            <li className="nav-item links">
                                <NavLink to='/work'>View Work</NavLink>
                            </li>
                            <li className="nav-item links">
                                <NavLink to='/blog'>Blogs</NavLink>
                            </li>
                            <li className="nav-item">
                                <a href='https://drive.google.com/uc?export=download&id=1gVVZMKtyS8Ww3BFeDhFbZu_pf2LIWmbB'><button><span className='download'>Download</span> Resume</button></a>
                            </li>

                        </ul>
                    </div>
                </div>
            </nav>
        </div>
    );
};

export default Navbar;